import { rootState } from '@core-interface'

export const getServicesDetailsFromReducer = (state:rootState) => state?.servicesReducer?.ServicesData;